export const I18N_FALLBACK_LNG = ['en'];
export const I18N_WHITELIST = ['en', 'vi'];
